import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import CustomersContext from "./context";
import { useNavigate } from "react-router-dom";

export const useCustomersManager = () => {
  const navigate = useNavigate();
  const [request, setRequest] = useState({
    loading: true,
    data: [],
    page: 0,
    limit: 100,
  });

  const getCustomers = useCallback(async () => {
    const mData = { ...request };
    try {
      request.loading = true;
      //showLoading();
      const { data: response, error } = await axios.get(
        `/customers?&page=${request.page + 1}&limit=${request.limit}`,
      );

      if (error) throw new Error(error);

      const formattedData = response.data.map(
        ({ name, businessName, phone, address, ...p }, index) => ({
          ...p,
          id: p._id,
          name,
          phone,
          date: new Date(p.createdAt).toLocaleString(),
          updatedAt: new Date(p.updatedAt).toLocaleString(),
          showDetails: () => navigate(`./${p._id}`),
        }),
      );

      Object.assign(mData, { ...response, data: formattedData });
    } catch (e) {
      console.log(e);
      mData.data = [];
    } finally {
      mData.loading = false;
      await sleep(1000);
      setRequest(mData);
    }
  }, [request.page, request.limit]);

  const onNextPage = ({ page, pageSize }) => {
    if (request.loading) return;
    setRequest((o) => ({ ...o, page, loading: true, limit: pageSize }));
  };

  useEffect(() => {
    async function fetchdata() {
      return getCustomers();
    }

    fetchdata();
    return () => {};
  }, [getCustomers]);

  return {
    request,
    getCustomers,
    onNextPage,
  };
};

export const useCustomers = () => useContext(CustomersContext);
